export function urlToFile(url: string, filename: string, mimeType: string): Promise<File> {
  return fetch(url)
    .then((res) => {
      return res.arrayBuffer();
    })
    .then((buf) => {
      return new File([buf], filename, { type: mimeType });
    });
}
